import styled from 'styled-components'

import { ArrowDown2Icon, useHapticFeedback } from '@blade/ui-kit'
import { CurrencyIcon } from '@root/entities/currency/ui'

import type { CurrencyModel } from '@root/entities/currency'

type TransferCardCurrencyButtonProps = {
  currency: CurrencyModel
  onClick: () => void
}

export const TransferCardCurrencyButton: React.FC<
  TransferCardCurrencyButtonProps
> = ({ currency, onClick }) => {
  const haptics = useHapticFeedback()
  return (
    <Root
      onClick={() => {
        haptics.impactOccurred('light')
        onClick()
      }}
      type="button"
    >
      <CurrencyIcon size={18} currency={currency} withGoogleLens={false} />
      <Ticker>{currency.ticker}</Ticker>
      <ArrowDown2Icon />
    </Root>
  )
}

const Root = styled.button`
  color: var(--text-12);
  all: unset;
  cursor: pointer;
  border-radius: 64px;
  padding-block: 4px;
  padding-inline: 4px 8px;

  display: grid;
  gap: 4px;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  transition: background 0.2s ease-in-out;

  &:hover {
    background: var(--backgroundA-3);
  }
`

const Ticker = styled.div`
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
`
